module.exports = __webpack_public_path__ + "static/media/13.e9c8208b.svg";